import Chip from '../ui/chip/Chip';
import Modal from '../common/Modal';

const CandidateDetailsModal = ({
  name,
  exp = '-',
  skill = [],
  designation = '-',
  currentCTC = '-',
  expectedCTC = '-',
  ...restModalProps
}) => {
  let beginner = [];
  let intermediate = [];
  let expert = [];

  skill.forEach((item) => {
    switch (item?.proficiency) {
      case 1:
        beginner.push(item.name);
        break;
      case 2:
        intermediate.push(item.name);
        break;
      case 3:
        expert.push(item.name);
        break;
    }
  });

  return (
    <Modal {...restModalProps}>
      <div
        className="grid grid-cols-1 gap-4 py-2"
        onDragStart={(e) => e.preventDefault()}
      >
        <div className="flex">
          <div className="basis-1/2 font-medium">Name:</div>
          <div className="basis-1/2 ">{name}</div>
        </div>
        <div className="flex">
          <div className="basis-1/2 font-medium">Experience:</div>
          <div className="basis-1/2 ">{exp}</div>
        </div>
        <div className="flex">
          <div className="basis-1/2 font-medium">Designation:</div>
          <div className="basis-1/2 ">{designation}</div>
        </div>
        <div className="flex">
          <div className="basis-1/2 font-medium">Skill:</div>
          {skill.length ? (
            <div className="basis-1/2 ">
              <div className="flex space-x-4">
                <div className="flex items-center space-x-2">
                  <div className="h-3 w-3 rounded-full bg-primary p-1"></div>
                  <span>Expert level</span>
                </div>
                <div className="flex items-center space-x-2">
                  <div className="h-3 w-3 rounded-full bg-[#BAF639] p-1"></div>
                  <span>Intermediate level</span>
                </div>
                <div className="flex items-center space-x-2">
                  <div className="h-3 w-3 rounded-full bg-[#27CF4C] p-1"></div>
                  <span>Beginner level</span>
                </div>
              </div>
              <div className="flex flex-wrap pt-2">
                {beginner.map((item) => (
                  <Chip
                    key={item}
                    item={item}
                    inside={true}
                    color="bg-primary/10"
                  />
                ))}
              </div>
              <div className="flex flex-wrap pt-2">
                {intermediate.map((item) => (
                  <Chip
                    key={item}
                    item={item}
                    inside={true}
                    color="bg-[#BAF639]/20"
                  />
                ))}
              </div>
              <div className="flex flex-wrap pt-2">
                {expert.map((item) => (
                  <Chip
                    key={item}
                    item={item}
                    inside={true}
                    color="bg-[#27CF4C]/20"
                  />
                ))}
              </div>
            </div>
          ) : (
            <span>-</span>
          )}
        </div>
        <div className="flex">
          <div className="basis-1/2 font-medium">Current Salary:</div>
          <div className="basis-1/2 ">{currentCTC}</div>
        </div>
        <div className="flex">
          <div className="basis-1/2 font-medium">Expected Salary:</div>
          <div className="basis-1/2 ">{expectedCTC}</div>
        </div>
      </div>
    </Modal>
  );
};

export default CandidateDetailsModal;
